const NAME = 'ITERABLE';
const CNameMapping = {
  [NAME]: NAME,
  Iterable: NAME,
  iterable: NAME,
};

export { NAME, CNameMapping };
